window.EASE_QUIZ_EN = {
  "default": {
    "intro": {
      "badge": "Takes only 60 seconds",
      "titleHtml": "How stressed is your<br>nervous system <em>really?</em>",
      "sub": "Find out where your body needs support and which acupressure points fit.",
      "features": [
        {
          "icon": "clock",
          "cls": "ico-clock",
          "text": "8 short questions, done in under 60 seconds"
        },
        {
          "icon": "tap",
          "cls": "ico-tap",
          "text": "Just tap, no typing needed"
        },
        {
          "icon": "lock",
          "cls": "ico-lock",
          "text": "Personal acupressure recommendation at the end"
        }
      ],
      "cta": "Start nervous-system check now →",
      "trust": "10,000+ checks completed already"
    },
    "q1": {
      "step": "Question 1 of 8",
      "title": "What describes you best right now?",
      "sub": "Choose what feels strongest.",
      "options": [
        {
          "v": "unruhe",
          "score": 3,
          "icon": "swirl",
          "line": "Constant inner restlessness",
          "sub": "Racing thoughts, can't switch off"
        },
        {
          "v": "schlaf",
          "score": 3,
          "icon": "moon",
          "line": "Sleep problems",
          "sub": "Falling asleep, staying asleep, or waking up tired"
        },
        {
          "v": "verspannung",
          "score": 2,
          "icon": "neck",
          "line": "Neck & jaw tension",
          "sub": "Raised shoulders, clenched teeth"
        },
        {
          "v": "erschoepfung",
          "score": 3,
          "icon": "fatigue",
          "line": "Exhaustion & low drive",
          "sub": "Tired despite enough sleep, everything feels hard"
        },
        {
          "v": "konzentration",
          "score": 2,
          "icon": "focus",
          "line": "Focus & sensory overload",
          "sub": "Can't concentrate, head full, too many inputs"
        },
        {
          "v": "angst",
          "score": 3,
          "icon": "heart",
          "line": "Anxiety & tension",
          "sub": "Nervousness, racing heart, inner tightness"
        }
      ]
    },
    "q2": {
      "step": "Question 2 of 8",
      "title": "How stressed do you feel right now?",
      "sub": "Be honest: there is no wrong answer.",
      "emojis": [
        {
          "v": 1,
          "icon": "veryHappy",
          "label": "Barely"
        },
        {
          "v": 2,
          "icon": "calm",
          "label": "A little"
        },
        {
          "v": 3,
          "icon": "neutral",
          "label": "Medium"
        },
        {
          "v": 4,
          "icon": "stressed",
          "label": "Strong"
        },
        {
          "v": 5,
          "icon": "overwhelmed",
          "label": "Extreme"
        }
      ]
    },
    "q3": {
      "step": "Question 3 of 8",
      "title": "How long has this been going on?",
      "sub": "Since when have you felt this burden?",
      "options": [
        {
          "v": "wochen",
          "score": 1,
          "icon": "calendar",
          "line": "A few weeks"
        },
        {
          "v": "monate",
          "score": 2,
          "icon": "calendarRange",
          "line": "Several months"
        },
        {
          "v": "jahr",
          "score": 3,
          "icon": "calendarRange",
          "line": "Over a year"
        },
        {
          "v": "immer",
          "score": 4,
          "icon": "infinity",
          "line": "As long as I can remember"
        }
      ]
    },
    "q4new": {
      "step": "Question 4 of 8",
      "title": "When do you feel it most strongly?",
      "sub": "So we can recommend the best time to use it.",
      "options": [
        {
          "v": "morgen",
          "icon": "energy",
          "line": "In the morning when waking up",
          "sub": "hard to get into the day"
        },
        {
          "v": "job",
          "icon": "calendar",
          "line": "During the day / under pressure",
          "sub": "at work, during stress peaks"
        },
        {
          "v": "abend",
          "icon": "moon",
          "line": "Evenings / before sleep",
          "sub": "can't wind down"
        },
        {
          "v": "nacht",
          "icon": "moon",
          "line": "At night",
          "sub": "wake up, can't get back to sleep"
        },
        {
          "v": "termin",
          "icon": "clock",
          "line": "Before important events",
          "sub": "tension, nervousness"
        }
      ]
    },
    "q4": {
      "step": "Question 5 of 8",
      "title": "Do you feel it in your body too?",
      "sub": "Select everything that applies.",
      "next": "Continue →",
      "options": [
        {
          "v": "kopf",
          "score": 2,
          "icon": "head",
          "line": "Headaches or head pressure"
        },
        {
          "v": "nacken",
          "score": 2,
          "icon": "shoulder",
          "line": "Neck & shoulders tense"
        },
        {
          "v": "kiefer",
          "score": 2,
          "icon": "jaw",
          "line": "Jaw tight or teeth grinding"
        },
        {
          "v": "bauch",
          "score": 1,
          "icon": "gut",
          "line": "Stomach or digestion issues"
        },
        {
          "v": "nichts",
          "score": 0,
          "icon": "checkCircle",
          "line": "Rather few physical symptoms"
        }
      ]
    },
    "q5": {
      "step": "Question 6 of 8",
      "title": "What have you tried so far?",
      "sub": "Much of it helps, but often only on the surface.",
      "next": "Continue →",
      "options": [
        {
          "v": "meditation",
          "icon": "meditate",
          "line": "Meditation or breathing exercises"
        },
        {
          "v": "sport",
          "icon": "run",
          "line": "Sport or yoga"
        },
        {
          "v": "supplements",
          "icon": "pill",
          "line": "Supplements or tea"
        },
        {
          "v": "therapie",
          "icon": "user",
          "line": "Therapy or coaching"
        },
        {
          "v": "nichts",
          "icon": "checkCircle",
          "line": "Nothing specific yet"
        }
      ]
    },
    "q6": {
      "step": "Question 7 of 8",
      "title": "Does it affect your daily life?",
      "sub": "Work, relationships, energy: how much does it limit you?",
      "options": [
        {
          "v": "wenig",
          "score": 1,
          "icon": "spark",
          "line": "A bit, but I manage"
        },
        {
          "v": "mittel",
          "score": 2,
          "icon": "warning",
          "line": "Yes, it really bothers me",
          "sub": "I'm not the person I could be"
        },
        {
          "v": "stark",
          "score": 3,
          "icon": "heartBreak",
          "line": "Strongly, it drags me down",
          "sub": "Job, relationship or health suffer"
        },
        {
          "v": "extrem",
          "score": 4,
          "icon": "overwhelmed",
          "line": "Very strong, I'm at my limit",
          "sub": "I urgently need something that helps"
        }
      ]
    },
    "q7": {
      "step": "Question 8 of 8 - last question!",
      "title": "What do you want most?",
      "sub": "If one of these changed tomorrow: which would it be?",
      "options": [
        {
          "v": "ruhe",
          "icon": "zen",
          "line": "Finally find inner calm",
          "sub": "Stop racing thoughts, let go"
        },
        {
          "v": "schlaf",
          "icon": "moon",
          "line": "Sleep really well",
          "sub": "Fall asleep, stay asleep, wake refreshed"
        },
        {
          "v": "schmerz",
          "icon": "muscle",
          "line": "Release tension",
          "sub": "Neck, jaw, shoulders finally loose"
        },
        {
          "v": "energie",
          "icon": "energy",
          "line": "More energy & lightness",
          "sub": "Power for what matters to me"
        }
      ]
    },
    "loading": {
      "title": "Creating your stress profile...",
      "sub": "We're analyzing your answers and building personal recommendations.",
      "steps": [
        "Calculating stress level",
        "Recognizing symptom patterns",
        "Matching acupressure points",
        "Creating personal recommendation"
      ]
    },
    "email": {
      "title": "Your profile is ready!",
      "sub": "Enter your email and get your personal acupressure point recommendations instantly.",
      "placeholder": "Your email address",
      "submit": "Show my recommendation →",
      "trust": "No spam. Unsubscribe anytime.",
      "bonusHint": "A small surprise is waiting with your result."
    },
    "result": {
      "pointsTitle": "Your recommended acupressure points",
      "ctaHtml": "<strong>EASE makes these points everyday-ready.</strong><br>A necklace whose pendant is a precision acupressure stylus: worn on CV17, taken off for any other point.",
      "ctaBtn": "Show my EASE offer →",
      "bonusHint": "As a little extra with your result: 10% off",
      "bonusCode": "TAKEITEASE10"
    },
    "empathyMessages": {
      "unruhe": "Feeling unable to switch off is more common than you think. You're not alone.",
      "schlaf": "Poor sleep wears you down. Especially when you do everything right and it still doesn't work.",
      "verspannung": "Your body carries the tension your mind won't release. That's draining.",
      "erschoepfung": "Tired despite sleep is one of the most common signs of nervous-system overload.",
      "konzentration": "Full head, no room for focus. That's not a discipline problem, it's overstimulation.",
      "angst": "Anxiety and tension are real body signals. Not 'too sensitive', just overloaded."
    },
    "durationEmpathy": {
      "wochen": "You're early. Let's look at when it tips for you.",
      "monate": "Over months this has settled in. This is where many stop looking.",
      "jahr": "Over a year is a lot, that sits deep. Let's look at when it tips.",
      "immer": "As long as you can remember: that has become your baseline. That can change too."
    },
    "triggerEmpathy": {
      "morgen": "If the day starts tense, your NS didn't switch off at night.",
      "job": "Under pressure you see what has entrenched. Let's find where exactly.",
      "abend": "When sleep doesn't hold at night, your body pays during the day.",
      "nacht": "Waking at night is one of the most common and least understood stress patterns.",
      "termin": "Before important appointments tension builds. Your body notices first."
    },
    "stressEmpathy": {
      "1": "Good that you're staying ahead of it.",
      "2": "This is a good time to do something for yourself.",
      "3": "Many people know this. And there is a way out.",
      "4": "That sounds genuinely heavy. Good that you're here.",
      "5": "That's a lot. You deserve support, and you're on the right path."
    },
    "alltagEmpathy": {
      "wenig": "Good that you're early. Prevention is easier than repair.",
      "mittel": "Being honest about this is already step one. Your nervous system needs support.",
      "stark": "That's really a lot. You deserve to feel like yourself again.",
      "extrem": "Actively looking for solutions shows strength. Let's see what can help you."
    },
    "pointsDB": {
      "kg17": {
        "name": "CV17 - Sea of Tranquility",
        "icon": "brain",
        "location": "Center of the sternum",
        "desc": "The classic point for inner restlessness. Can calm the nervous system and support deep breathing."
      },
      "ht7": {
        "name": "HT7 - Spirit Gate",
        "icon": "zen",
        "location": "Inside of the wrist",
        "desc": "Ideal before sleep. Can calm the mind and help you let go."
      },
      "gb21": {
        "name": "GB21 - Shoulder Well",
        "icon": "muscle",
        "location": "Middle of the shoulder",
        "desc": "The point for neck and shoulder tension. Can release tension that builds through the day."
      },
      "gb20": {
        "name": "GB20 - Wind Pool",
        "icon": "leaf",
        "location": "Base of skull at the neck",
        "desc": "Can help with head pressure, neck tension and a heavy head."
      },
      "li4": {
        "name": "LI4 - Union Valley",
        "icon": "hand",
        "location": "Between thumb and index finger",
        "desc": "The best-known acupressure point. Used for head pressure and tension, can support focus."
      },
      "si3": {
        "name": "SI3 - Back Ravine",
        "icon": "wave",
        "location": "Edge of hand, pinky side",
        "desc": "A classic for jaw and neck tension, for example teeth clenching."
      },
      "pc6": {
        "name": "PC6 - Inner Gate",
        "icon": "heart",
        "location": "Inside of the forearm",
        "desc": "Used for racing heart and inner agitation, especially with stress-related discomfort."
      }
    },
    "attemptEmpathy": {
      "tried": "So you have genuinely tried. That none of it held wasn't down to you, it's that those routes work on the mind and not on the body.",
      "none": "Not having tried anything yet is no disadvantage. You simply haven't been talked into something that doesn't fit."
    }
  },
  "einblick1": {
    "q1_echo": {
      "schlaf": "sleep problems",
      "unruhe": "constant restlessness",
      "verspannung": "neck tension",
      "erschoepfung": "exhaustion",
      "konzentration": "trouble concentrating",
      "angst": "tension"
    },
    "q3_echo": {
      "wochen": "for a few weeks",
      "monate": "for months",
      "jahr": "for over a year",
      "immer": "as long as you can remember"
    },
    "trigger_line": {
      "morgen": "strongest in the morning",
      "job": "under pressure at work",
      "abend": "in the evening when you want to wind down",
      "nacht": "at night with waking",
      "termin": "before important appointments"
    },
    "stat": {
      "schlaf": {
        "num": "78%",
        "label": "of people with <strong>this combination</strong> report waking between 2 and 4 a.m., the cortisol peak."
      },
      "unruhe": {
        "num": "2 in 3",
        "label": "adults report chronic inner restlessness, without recognizing it as stress."
      },
      "verspannung": {
        "num": "70%",
        "label": "of tension headaches don't start in muscle, but in a nervous system that won't switch off."
      },
      "erschoepfung": {
        "num": "Tired despite sleep",
        "label": "is the most common sign of nervous-system overload. Your body sleeps, the sympathetic system keeps running."
      },
      "konzentration": {
        "num": "Overstimulation",
        "label": "blocks clear thinking, not lack of discipline. The brain prioritizes survival over focus."
      },
      "angst": {
        "num": "Vagus nerve",
        "label": "runs on low power with chronic tension. Without activation, calming down is hard."
      },
      "default": {
        "num": "78%",
        "label": "of people report first effects after a few weeks of acupressure."
      }
    },
    "insight": {
      "schlaf": "Classic pattern for a stuck sympathetic system: your body doesn't enter repair mode at night.",
      "unruhe": "Racing thoughts are the effect, not the cause. A constantly activated sympathetic system keeps the mind alert.",
      "verspannung": "When the mind won't let go, the body holds the tension. Massage helps briefly, then it returns.",
      "erschoepfung": "Your body sleeps, the sympathetic system keeps running. Recovery needs the parasympathetic, and it barely engages under chronic stress.",
      "konzentration": "When your head is full, there's no room for clear thought. Not a character trait, but overstimulation.",
      "angst": "With chronic tension the vagus nerve, your NS brake, runs on low power.",
      "default": "Stress feels different for everyone. The mechanics behind it: a nervous system that forgot the off switch."
    },
    "reframe": {
      "schlaf": "Not psychological, not a discipline issue. Your vagus nerve forgot the activation exercise. That can be relearned.",
      "unruhe": "This isn't 'just how I am'. Your sympathetic system is stuck in alarm mode. That can be reversed.",
      "verspannung": "It's not a bad mattress. Your body stays on alert at night. Acupressure can meet it there.",
      "erschoepfung": "That's not laziness, but a nervous system without a brake. With the brake, energy returns.",
      "konzentration": "You're not 'too dumb'. Your NS puts survival over focus right now. That can be retrained.",
      "angst": "You're not 'too sensitive'. Your NS never learned the off switch. It can learn it.",
      "default": "You're not doing anything wrong. This is an NS pattern, and patterns can change."
    }
  },
  "einblick2": {
    "tried_echo": {
      "meditation": "Meditation",
      "sport": "Sport",
      "supplements": "Supplements",
      "therapie": "Therapy"
    },
    "time_label": {
      "morgen": "in the morning, right after waking",
      "job": "during the day, before stress peaks",
      "abend": "in the evening, 20 min before sleep",
      "nacht": "at night when waking instead of getting up",
      "termin": "10 min before important appointments"
    },
    "tone_by_impact": {
      "wenig": "You're already doing a lot right, you just need the right tool.",
      "mittel": "This is a good moment, there's still room before it becomes chronic.",
      "stark": "You deserve to feel like yourself again. Without an 8-week program.",
      "extrem": "At your limit you need something that works in 5 to 10 minutes and is always with you."
    }
  },
  "timeBoxTexts": {
    "morgen": "Right after waking, 5 to 10 min on the sternum for a calm start.",
    "job": "Lunch break or just before meetings: 5 to 10 min, discreet.",
    "abend": "Evening, 20 min before bed: your wind-down routine.",
    "nacht": "When waking at night: 5 to 10 min on CV17 instead of getting up.",
    "termin": "10 min before important situations: on the wrist (HT7) or sternum (CV17)."
  },
  "ui": {
    "and": "and",
    "little": "little",
    "bodyFallback": "your body",
    "bodyAreas": {
      "kopf": "Head",
      "nacken": "Neck",
      "kiefer": "Jaw",
      "bauch": "Belly"
    },
    "einblick1Step": "Short break · Insight",
    "einblick1Badge": "What we read from your answers",
    "einblick1Source": "Source: DAK health report · cortisol studies",
    "einblick1Next": "Got it, continue →",
    "einblick2Step": "Good to know",
    "einblick2Badge": "What your previous attempts tell us",
    "einblick2Source": "Source: WHO acupuncture review · vagus activation studies",
    "einblick2Next": "Interesting, last question →",
    "loadingAlmostTitle": "Almost done …",
    "loadingAlmostSub": "You'll see your profile in a moment.",
    "recapEyebrow": "You told me",
    "timeBoxTitle": "Best time to use",
    "safetyNote": "With high strain: EASE is a wellness product. If this really burdens you, also speak with your GP or therapist.",
    "stressSymptomsDefault": "stress symptoms",
    "forAWhile": "for a while",
    "editorOpen": "Theme editor: open quiz preview",
    "bonusCodeLabel": "Code:",
    "resultBonusCodeLabel": "Code:",
    "yourPattern": "your pattern",
    "blurPointsPrefix": "Your 3 points for"
  },
  "copy": {
    "weiter": "Continue →",
    "individually": "flexible",
    "stressMeterLabel": "Stress level ({pct}%)",
    "profileLabels": {
      "schlaf": "Sleep profile",
      "unruhe": "Stress profile",
      "verspannung": "Tension profile",
      "erschoepfung": "Exhaustion profile",
      "konzentration": "Overstimulation profile",
      "angst": "Tension profile",
      "default": "Stress profile"
    },
    "patternLabels": {
      "morgen": "morning pattern",
      "job": "work-stress pattern",
      "abend": "evening pattern",
      "nacht": "nighttime pattern",
      "termin": "pre-event tension pattern",
      "default": "your pattern"
    },
    "freshStart": "your fresh start",
    "timeLabels": {
      "morgen": "morning use",
      "job": "daytime use",
      "abend": "evening use",
      "nacht": "nighttime use",
      "termin": "use before appointments",
      "default": "use"
    },
    "loadingSteps": {
      "analyze": "Analyzing your <em>{profile}</em>",
      "mapPattern": "Mapping <em>{pattern}</em>",
      "factorTried": "Factoring in <em>{tried}</em>",
      "pickPoints": "Selecting 3 points for <em>{time}</em>"
    },
    "loadingTitle": "Creating your {profile} profile…",
    "einblick1Headline": "You said: <em>{q1} {q3}</em>{suffix}.",
    "einblick1TriggerSuffix": ", and {trigger}",
    "einblick2Headline": "You tried <em>{tried}</em>, and <em>{body}</em> are still tense.",
    "einblick2StatNum": "{count} approaches",
    "einblick2StatLabel": "you've tried so far: <strong>{layers}</strong>",
    "einblick2Body": "All of it makes sense. But it doesn't reach the vagus nerve or the fascia line across chest, neck and jaw. You're missing physical access.",
    "einblick2Reframe": "<strong>CV17</strong> in the center of the sternum is the TCM \"Sea of Tranquility\". Especially {triggerBridge}, acupressure there works directly on the vagus nerve. {tone}",
    "einblick2TriggerBridgeNight": "for people who wake at night",
    "einblick2TriggerBridgeEvening": "with evening tension",
    "einblick2TriggerBridgeDefault": "with physical tension",
    "layerInsight": {
      "mental": "from above (mind)",
      "biochem": "from inside (biochemistry)",
      "physical": "with movement",
      "none": "in spots",
      "joiner": " + "
    },
    "recapTriedWith": "So far you've tried <b>{list}</b>",
    "recapTriedNone": "So far you haven't tried anything specific",
    "recapImpact": {
      "wenig": "but you're managing",
      "mittel": "and it really bothers you",
      "stark": "and it's dragging you down",
      "extrem": "and you're at your limit"
    },
    "recapWish": {
      "ruhe": "find inner calm",
      "schlaf": "sleep really well",
      "schmerz": "release tension",
      "energie": "more energy",
      "default": "relief"
    },
    "recapTemplate": "<b>{q1}</b> {q3}, {triggerPart}and it also shows in <b>{body}</b>. {triedPart}, and {impactPart}. Your wish: <b>{wish}</b>.",
    "recapTriggerPart": "strongest {trigger}, ",
    "socialProof": {
      "schlaf": "<strong style=\"color:#2d5a3f\">78% of users with your profile</strong> report winding down faster in the evening after 2–3 weeks.",
      "unruhe": "<strong style=\"color:#2d5a3f\">71% report</strong> racing thoughts becoming less frequent after a few weeks.",
      "verspannung": "<strong style=\"color:#2d5a3f\">82% feel</strong> relief in neck and shoulders within the first weeks.",
      "erschoepfung": "<strong style=\"color:#2d5a3f\">68% report</strong> feeling more rested in the morning.",
      "konzentration": "<strong style=\"color:#2d5a3f\">74% report</strong> thinking more clearly after short acupressure breaks.",
      "angst": "<strong style=\"color:#2d5a3f\">76% report</strong> acute tension easing faster.",
      "default": "<strong style=\"color:#2d5a3f\">Many users report</strong> first effects within a few weeks."
    },
    "emailTeasers": {
      "default": "Your nervous system shows clear overload signs.",
      "schlaf": "Your nervous system won't settle at night, that affects your whole sleep cycle.",
      "unruhe": "Your nervous system is stuck in stress mode, hence the constant racing thoughts.",
      "verspannung": "Your body holds tension your mind won't release, especially neck and jaw.",
      "erschoepfung": "Your nervous system runs hot even when you're exhausted, a classic overload pattern.",
      "konzentration": "Your nervous system is overstimulated, leaving no room for focus.",
      "angst": "Anxiety and tension often flip the alarm mode. Body and mind stay on high alert."
    },
    "emailBlur1": "Your 3 points for <strong>{pattern}</strong>: CV17, {point}…",
    "emailBlur2": "⏰ Use <strong>{time}</strong>…",
    "emailBlur3Tried": "Why <strong>{list}</strong> weren't enough…",
    "emailBlur3Default": "Your everyday reset, 5 to 10 minutes…",
    "emailInvalid": "Please enter a valid email",
    "emailCheckboxRequired": "Please confirm the checkbox to continue.",
    "results": {
      "low": {
        "headline": "Light strain",
        "sub": "Your nervous system is largely in balance. Targeted acupressure can help you keep it that way."
      },
      "medium": {
        "headline": "Moderate strain",
        "sub": "Your nervous system shows early overload signs. Now is a good time to act."
      },
      "high": {
        "headline": "Elevated strain",
        "sub": "Your nervous system is clearly overloaded. Targeted vagus stimulation can make a difference."
      },
      "severe": {
        "headline": "High strain",
        "sub": "Your nervous system needs support now. The good news: with the right points you can start immediately."
      }
    },
    "multiEmpathyBody": "When stress sits in the body, mental techniques often aren't enough. Your nervous system needs physical access.",
    "multiEmpathyBelly": "Your belly often reacts first to stress. A clear signal from your nervous system.",
    "stressMeterShort": {
      "low": "Light",
      "medium": "Medium",
      "elevated": "Elevated",
      "high": "High"
    },
    "loadingProfileShort": {
      "schlaf": "Sleep",
      "unruhe": "Stress",
      "verspannung": "Tension",
      "erschoepfung": "Exhaustion",
      "konzentration": "Overstimulation",
      "angst": "Tension",
      "default": "Stress"
    },
    "emailPlaceholderInvalid": "Please enter a valid email",
    "loadingTitleTemplate": "Creating your {profile} profile…"
  }
};
